import Rest from 'common/rest'

const TOKEN_TTL_SECONDS = 120
const SUPPORT_ERROR_MESSAGE = 'Nao foi possivel concluir o envio dos documentos. Tente novamente em alguns instantes ou contate o suporte.'

export default {
  mixins: [Rest],
  data() {
    return {
      loading: true,
      errorMessage: '',
      alreadySigned: false,
      justSigned: false,
      codigoAssinatura: null,
      currentStep: 1,
      wizardComplete: false,
      busy: false,
      cpf: '',
      nome: '',
      telefone: '',
      email: '',
      password: '',
      passwordConfirm: '',
      passwordConfirmTouched: false,
      passwordConfirmError: '',
      cadastroExistente: false,
      possuiAssinaturaAnterior: false,
      cadastroEditavel: false,
      cadastroEdicaoAtivada: false,
      cadastroMaskedNome: '',
      cadastroMaskedTelefone: '',
      cadastroMaskedEmail: '',
      cadastroMaskedCpf: '',
      cadastroUsuarioId: 0,
      dataNascimento: '',
      sexo: '',
      token: '',
      tokenChannel: '',
      tokenExpiresAt: 0,
      emailValidationView: 'email',
      emailTokenValues: ['', '', '', ''],
      phoneValidationView: 'phone',
      phoneTokenValues: ['', '', '', ''],
      timerNow: Date.now(),
      tokenTimer: null,
      frenteDocumento: '',
      frenteIsPdf: false,
      versoDocumento: '',
      frenteDocumentoName: '',
      versoDocumentoName: '',
      uploadLoadingFrente: false,
      uploadLoadingVerso: false,
      uploadErrorFrente: false,
      uploadErrorVerso: false,
      uploadLoadingRosto: false,
      uploadErrorRosto: false,
      fotoRosto: '',
      fotoRostoName: '',
      trabalhadorId: 0,
      stepMessage: '',
      stepError: false,
      dadosFuncionarioCerebro: null,
      funcionarioCerebroEditavel: false,
      funcionarioCerebroEdicaoAtivada: false,
    }
  },
  computed: {
    tenant() {
      return this.$route.params.tenant
    },
    tenantTitleCase() {
      const value = String(this.tenant || '').trim()
      if (!value) {
        return ''
      }

      return value
        .toLowerCase()
        .split(/([\s_-]+)/)
        .map((part) => {
          if (/^[\s_-]+$/.test(part)) {
            return part
          }

          return part.charAt(0).toUpperCase() + part.slice(1)
        })
        .join('')
    },
    idConsulta() {
      return this.$route.params.idConsulta
    },
    tokenRemainingSeconds() {
      if (!this.tokenExpiresAt) {
        return 0
      }

      const diff = Math.floor((this.tokenExpiresAt - this.timerNow) / 1000)
      return diff > 0 ? diff : 0
    },
    tokenExpired() {
      return !!this.tokenExpiresAt && this.tokenRemainingSeconds === 0
    },
    tokenCountdown() {
      if (!this.tokenExpiresAt) {
        return ''
      }

      const minutes = String(Math.floor(this.tokenRemainingSeconds / 60)).padStart(2, '0')
      const seconds = String(this.tokenRemainingSeconds % 60).padStart(2, '0')
      return minutes + ':' + seconds
    },
    tokenResendLabel() {
      return this.tokenExpired ? 'Reenviar Código' : 'Reenviar Código ' + this.tokenCountdown
    },
    canSaveDocumentos() {
      var hasDocumentos = this.frenteIsPdf
        ? !!this.frenteDocumento
        : !!this.frenteDocumento && !!this.versoDocumento

      return hasDocumentos
        && !this.uploadLoadingFrente
        && !this.uploadLoadingVerso
        && !this.uploadErrorFrente
        && !this.uploadErrorVerso
    },
    emailValidated() {
      return this.currentStep > 1
    },
    identidadeValidated() {
      return this.currentStep > 2
    },
    telefoneValidated() {
      if (this.cadastroExistente) {
        return true
      }

      return this.currentStep > 3
    },
    senhaValidated() {
      if (this.cadastroExistente && this.currentStep >= 4) {
        return true
      }

      if (this.currentStep <= 4) {
        return false
      }

      return !!this.password && !this.validatePasswordConfirmation()
    },
    emailStatusLabel() {
      return this.email ? this.email : 'Confirme seu e-mail'
    },
    identidadeStatusLabel() {
      return this.identidadeValidated ? 'Identidade validada' : 'Confirme sua identidade'
    },
    telefoneStatusLabel() {
      return this.telefone ? this.telefone : 'Confirme seu telefone'
    },
    senhaStatusLabel() {
      if (this.cadastroExistente && this.senhaValidated) {
        return 'Cadastro existente validado'
      }

      return this.senhaValidated ? 'Senha criada com sucesso' : 'Crie sua senha'
    },
    canAdvanceValidationBoard() {
      return this.emailValidated && this.identidadeValidated && this.telefoneValidated && this.senhaValidated
    },
    routeStep() {
      return String((this.$route && this.$route.params && this.$route.params.step) || '').toLowerCase()
    },
    isStepRoute() {
      return ['email', 'identidade', 'telefone', 'senha'].includes(this.routeStep)
    },
    showValidationBoard() {
      return !this.isStepRoute && this.currentStep <= 4
    },
    possuiDadosCerebro() {
      return !!(this.dadosFuncionarioCerebro && this.dadosFuncionarioCerebro.existe)
    },
  },
  mounted() {
    this.restoreWizardState()
    this.syncStepFromRoute()
    this.loadAssinaturaStatus()
    this.ensureTokenTimer()
  },
  beforeDestroy() {
    this.stopTokenTimer()
  },
  methods: {
    assinarRouteName() {
      if (String(this.$route.name || '').indexOf('empresa.') === 0) {
        return 'empresa.funcionario.aso.assinar'
      }

      return 'web.funcionario.aso.assinar'
    },
    assinarStepRouteName() {
      if (String(this.$route.name || '').indexOf('empresa.') === 0) {
        return 'empresa.funcionario.aso.assinar.step'
      }

      return 'web.funcionario.aso.assinar.step'
    },
    goToValidationRoute(step) {
      const tenant = this.tenant
      const idConsulta = this.idConsulta
      this.$router.push({
        name: this.assinarStepRouteName(),
        params: {
          tenant,
          idConsulta,
          step,
        },
      })
    },
    goToBoardRoute() {
      const tenant = this.tenant
      const idConsulta = this.idConsulta
      this.$router.push({
        name: this.assinarRouteName(),
        params: {
          tenant,
          idConsulta,
        },
      })
    },
    syncStepFromRoute() {
      if (this.routeStep === 'email') {
        this.goToEmailForm()
        return
      }

      if (this.routeStep === 'identidade') {
        this.currentStep = 2
        return
      }

      if (this.routeStep === 'telefone') {
        this.currentStep = 3
        this.phoneValidationView = 'phone'
        return
      }

      if (this.routeStep === 'senha') {
        this.currentStep = 4
      }
    },
    validationClass(key) {
      return {
        'aso-public-entry__validation-item--active': this.isValidationStepActive(key),
        'aso-public-entry__validation-item--done': this.isValidationStepDone(key),
      }
    },
    isValidationStepDone(key) {
      if (key === 'email') {
        return this.emailValidated
      }

      if (key === 'identidade') {
        return this.identidadeValidated
      }

      if (key === 'telefone') {
        return this.telefoneValidated
      }

      if (key === 'senha') {
        return this.senhaValidated
      }

      return false
    },
    isValidationStepActive(key) {
      if (key === 'email') {
        return this.currentStep === 1
      }

      if (key === 'identidade') {
        return this.currentStep === 2
      }

      if (key === 'telefone') {
        return this.currentStep === 3
      }

      if (key === 'senha') {
        return this.currentStep === 4
      }

      return false
    },
    isValidationActionVisible(key) {
      if (this.currentStep > 4) {
        return false
      }

      const steps = ['email', 'identidade', 'telefone', 'senha']
      const nextPending = steps.find((stepKey) => !this.isValidationStepDone(stepKey))
      return key === nextPending
    },
    goToValidationStep(key) {
      if (key === 'email') {
        this.goToValidationRoute('email')
        return
      }

      if (key === 'identidade') {
        if (!this.emailValidated) {
          this.goToValidationRoute('email')
          this.setStepMessage('Valide o e-mail antes de seguir para identidade.', true)
          return
        }

        this.goToValidationRoute('identidade')
        return
      }

      if (key === 'telefone' || key === 'senha') {
        if (key === 'telefone' && !this.identidadeValidated) {
          this.goToValidationRoute('identidade')
          this.setStepMessage('Conclua a validação de identidade antes de telefone.', true)
          return
        }

        if (key === 'senha' && !this.telefoneValidated) {
          this.goToValidationRoute('telefone')
          this.setStepMessage('Conclua a validação de telefone antes de senha.', true)
          return
        }

        this.goToValidationRoute(key)
        return
      }
    },
    resetValidationBoard() {
      this.currentStep = 1
      this.emailValidationView = 'email'
      this.emailTokenValues = ['', '', '', '']
      this.phoneValidationView = 'phone'
      this.phoneTokenValues = ['', '', '', '']
      this.token = ''
      this.tokenChannel = ''
      this.tokenExpiresAt = 0
      this.stopTokenTimer()
      this.cpf = ''
      this.nome = ''
      this.telefone = ''
      this.email = ''
      this.password = ''
      this.passwordConfirm = ''
      this.passwordConfirmTouched = false
      this.passwordConfirmError = ''
      this.cadastroExistente = false
      this.possuiAssinaturaAnterior = false
      this.cadastroEditavel = false
      this.cadastroEdicaoAtivada = false
      this.cadastroMaskedNome = ''
      this.cadastroMaskedTelefone = ''
      this.cadastroMaskedEmail = ''
      this.cadastroMaskedCpf = ''
      this.cadastroUsuarioId = 0
      this.dataNascimento = ''
      this.sexo = ''
      this.trabalhadorId = 0
      this.dadosFuncionarioCerebro = null
      this.funcionarioCerebroEditavel = false
      this.funcionarioCerebroEdicaoAtivada = false
      this.setStepMessage('', false)
    },
    advanceValidationBoard() {
      if (!this.canAdvanceValidationBoard) {
        this.setStepMessage('Conclua as quatro validações para continuar.', true)
        return
      }

      this.currentStep = 5
      this.setStepMessage('Validações concluídas. Continue com o upload dos documentos.', false)
    },
    stepClass(step) {
      return {
        'aso-public-entry__steps-item': true,
        'aso-public-entry__steps-item--active': this.currentStep === step,
        'aso-public-entry__steps-item--done': this.currentStep > step,
      }
    },
    responsePayload(result) {
      const response = Array.isArray(result) && result.length ? result[0] : null
      return response && response.data && typeof response.data === 'object' ? response.data : {}
    },
    responseStatus(result) {
      const response = Array.isArray(result) && result.length ? result[0] : null
      return response && typeof response.status === 'number' ? response.status : 0
    },
    apiServicePath(service) {
      const clean = String(service || '').replace(/^\/+/, '')
      return this.tenant ? this.tenant + '/' + clean : clean
    },
    apiGet(service, params) {
      return this.get(this.apiServicePath(service), params, true)
    },
    apiPost(service, params, filters) {
      return this.post(this.apiServicePath(service), params, filters, true)
    },
    responseMessage(result, fallback) {
      const response = Array.isArray(result) && result.length ? result[0] : null
      if (response && response.msg) {
        return response.msg
      }

      const payload = this.responsePayload(result)
      if (payload && payload.message) {
        return payload.message
      }

      return fallback
    },
    setStepMessage(message, isError) {
      this.stepMessage = message
      this.stepError = !!isError
    },
    logRequestError(context, details) {
      // Keep technical details available for diagnostics without exposing internals to end users.
      // eslint-disable-next-line no-console
      console.error('[ASO Upload Error][' + context + ']', details)
    },
    getStorageKey() {
      return 'asoPublicWizard:' + this.tenant + ':' + this.idConsulta
    },
    persistWizardState() {
      if (typeof window === 'undefined' || this.alreadySigned) {
        return
      }

      const data = {
        currentStep: this.currentStep,
        emailValidationView: this.emailValidationView,
        emailTokenValues: this.emailTokenValues,
        phoneValidationView: this.phoneValidationView,
        phoneTokenValues: this.phoneTokenValues,
        cpf: this.cpf,
        nome: this.nome,
        telefone: this.telefone,
        email: this.email,
        cadastroExistente: this.cadastroExistente,
        possuiAssinaturaAnterior: this.possuiAssinaturaAnterior,
        cadastroEditavel: this.cadastroEditavel,
        cadastroEdicaoAtivada: this.cadastroEdicaoAtivada,
        cadastroMaskedNome: this.cadastroMaskedNome,
        cadastroMaskedTelefone: this.cadastroMaskedTelefone,
        cadastroMaskedEmail: this.cadastroMaskedEmail,
        cadastroMaskedCpf: this.cadastroMaskedCpf,
        cadastroUsuarioId: this.cadastroUsuarioId,
        dataNascimento: this.dataNascimento,
        sexo: this.sexo,
        tokenChannel: this.tokenChannel,
        tokenExpiresAt: this.tokenExpiresAt,
        trabalhadorId: this.trabalhadorId,
        dadosFuncionarioCerebro: this.dadosFuncionarioCerebro,
        funcionarioCerebroEditavel: this.funcionarioCerebroEditavel,
        funcionarioCerebroEdicaoAtivada: this.funcionarioCerebroEdicaoAtivada,
      }

      window.localStorage.setItem(this.getStorageKey(), JSON.stringify(data))
    },
    restoreWizardState() {
      if (typeof window === 'undefined') {
        return
      }

      const saved = window.localStorage.getItem(this.getStorageKey())
      if (!saved) {
        return
      }

      try {
        const parsed = JSON.parse(saved)
        var restoredStep = Number(parsed.currentStep || 1)
        this.currentStep = restoredStep === 7 ? 2 : restoredStep
        this.emailValidationView = parsed.emailValidationView === 'token' ? 'token' : 'email'
        this.emailTokenValues = Array.isArray(parsed.emailTokenValues) && parsed.emailTokenValues.length === 4
          ? parsed.emailTokenValues.map((value) => this.onlyDigits(value).slice(0, 1))
          : ['', '', '', '']
        this.phoneValidationView = parsed.phoneValidationView === 'token' ? 'token' : 'phone'
        this.phoneTokenValues = Array.isArray(parsed.phoneTokenValues) && parsed.phoneTokenValues.length === 4
          ? parsed.phoneTokenValues.map((value) => this.onlyDigits(value).slice(0, 1))
          : ['', '', '', '']
        this.cpf = parsed.cpf || ''
        this.nome = parsed.nome || ''
        this.telefone = parsed.telefone || ''
        this.email = parsed.email || ''
        this.cadastroExistente = !!parsed.cadastroExistente
        this.possuiAssinaturaAnterior = !!parsed.possuiAssinaturaAnterior
        this.cadastroEditavel = !!parsed.cadastroEditavel
        this.cadastroEdicaoAtivada = !!parsed.cadastroEdicaoAtivada
        this.cadastroMaskedNome = parsed.cadastroMaskedNome || ''
        this.cadastroMaskedTelefone = parsed.cadastroMaskedTelefone || ''
        this.cadastroMaskedEmail = parsed.cadastroMaskedEmail || ''
        this.cadastroMaskedCpf = parsed.cadastroMaskedCpf || ''
        this.cadastroUsuarioId = Number(parsed.cadastroUsuarioId || 0)
        this.dataNascimento = parsed.dataNascimento || ''
        this.sexo = parsed.sexo || ''
        this.tokenChannel = parsed.tokenChannel || ''
        this.tokenExpiresAt = Number(parsed.tokenExpiresAt || 0)
        this.trabalhadorId = Number(parsed.trabalhadorId || 0)
        this.dadosFuncionarioCerebro = parsed.dadosFuncionarioCerebro || null
        this.funcionarioCerebroEditavel = !!parsed.funcionarioCerebroEditavel
        this.funcionarioCerebroEdicaoAtivada = !!parsed.funcionarioCerebroEdicaoAtivada
      } catch (error) {
        this.clearWizardState()
      }
    },
    clearWizardState() {
      if (typeof window === 'undefined') {
        return
      }

      window.localStorage.removeItem(this.getStorageKey())
    },
    setTokenExpiry() {
      this.timerNow = Date.now()
      this.tokenExpiresAt = this.timerNow + (TOKEN_TTL_SECONDS * 1000)
      this.ensureTokenTimer()
    },
    getTokenDigitInput(index, type) {
      if (typeof document === 'undefined') {
        return null
      }

      return document.querySelector('[data-token-index="' + index + '"][data-token-type="' + type + '"]')
    },
    focusTokenDigit(index, type) {
      const input = this.getTokenDigitInput(index, type)
      if (input && typeof input.focus === 'function') {
        input.focus()
      }
    },
    goToEmailForm() {
      this.currentStep = 1
      this.emailValidationView = 'email'
      this.token = ''
      this.emailTokenValues = ['', '', '', '']
    },
    goToEmailTokenForm() {
      this.currentStep = 1
      this.emailValidationView = 'token'
      this.emailTokenValues = ['', '', '', '']
      this.$nextTick(() => this.focusTokenDigit(0, 'email'))
    },
    onEmailTokenDigitInput(payload) {
      if (!payload || typeof payload.index !== 'number') {
        return
      }

      const value = this.onlyDigits(payload.value).slice(-1)
      this.$set(this.emailTokenValues, payload.index, value)

      if (value && payload.index < this.emailTokenValues.length - 1) {
        this.$nextTick(() => this.focusTokenDigit(payload.index + 1, 'email'))
      }
    },
    onEmailTokenDigitKeydown(payload) {
      if (!payload || typeof payload.index !== 'number') {
        return
      }

      if (payload.key === 'Backspace' && !this.emailTokenValues[payload.index] && payload.index > 0) {
        this.$nextTick(() => this.focusTokenDigit(payload.index - 1, 'email'))
      }
    },
    onEmailTokenPaste(event) {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault()
      }

      const text = event && event.clipboardData ? event.clipboardData.getData('text') : ''
      const digits = this.onlyDigits(text).slice(0, 4)
      if (digits.length !== 4) {
        return
      }

      this.emailTokenValues = digits.split('')
      this.$nextTick(() => this.focusTokenDigit(3, 'email'))
    },
    goToPhoneForm() {
      this.currentStep = 3
      this.phoneValidationView = 'phone'
      this.phoneTokenValues = ['', '', '', '']
    },
    goToPhoneTokenForm() {
      this.currentStep = 3
      this.phoneValidationView = 'token'
      this.phoneTokenValues = ['', '', '', '']
      this.$nextTick(() => this.focusTokenDigit(0, 'phone'))
    },
    onPhoneTokenDigitInput(payload) {
      if (!payload || typeof payload.index !== 'number') {
        return
      }

      const value = this.onlyDigits(payload.value).slice(-1)
      this.$set(this.phoneTokenValues, payload.index, value)

      if (value && payload.index < this.phoneTokenValues.length - 1) {
        this.$nextTick(() => this.focusTokenDigit(payload.index + 1, 'phone'))
      }
    },
    onPhoneTokenDigitKeydown(payload) {
      if (!payload || typeof payload.index !== 'number') {
        return
      }

      if (payload.key === 'Backspace' && !this.phoneTokenValues[payload.index] && payload.index > 0) {
        this.$nextTick(() => this.focusTokenDigit(payload.index - 1, 'phone'))
      }
    },
    onPhoneTokenPaste(event) {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault()
      }

      const text = event && event.clipboardData ? event.clipboardData.getData('text') : ''
      const digits = this.onlyDigits(text).slice(0, 4)
      if (digits.length !== 4) {
        return
      }

      this.phoneTokenValues = digits.split('')
      this.$nextTick(() => this.focusTokenDigit(3, 'phone'))
    },
    ensureTokenTimer() {
      if (!this.tokenExpiresAt || this.tokenExpired) {
        this.stopTokenTimer()
        return
      }

      if (this.tokenTimer) {
        return
      }

      this.tokenTimer = setInterval(() => {
        this.timerNow = Date.now()
        if (this.tokenExpired) {
          this.stopTokenTimer()
        }
      }, 1000)
    },
    stopTokenTimer() {
      if (!this.tokenTimer) {
        return
      }

      clearInterval(this.tokenTimer)
      this.tokenTimer = null
    },
    async loadAssinaturaStatus() {
      this.loading = true
      this.errorMessage = ''
      this.alreadySigned = false
      this.codigoAssinatura = null
      this.wizardComplete = false

      const idConsulta = Number(this.idConsulta)
      if (!idConsulta || Number.isNaN(idConsulta)) {
        this.loading = false
        this.errorMessage = 'Consulta inválida.'
        return
      }

      try {
        const result = await this.apiGet('funcionario/aso/verificar-documento/' + idConsulta)
        const status = this.responseStatus(result)
        if (status && status !== 200) {
          this.errorMessage = this.responseMessage(result, 'Não foi possível consultar a assinatura para esta consulta.')
          return
        }

        const payload = this.responsePayload(result)

        if (payload && payload.consultaExiste === false) {
          this.errorMessage = payload.message || 'Consulta não encontrada.'
          return
        }

        this.alreadySigned = !!payload.assinado
        this.codigoAssinatura = payload.codigo || null

        if (this.alreadySigned) {
          this.wizardComplete = true
          this.clearWizardState()
          this.stopTokenTimer()
        } else {
          await this.carregarDadosFuncionarioConsulta()
        }
      } catch (error) {
        this.errorMessage = 'Não foi possível consultar o status da assinatura.'
      } finally {
        this.loading = false
      }
    },
    async carregarDadosFuncionarioConsulta() {
      const idConsulta = Number(this.idConsulta)
      if (!idConsulta || Number.isNaN(idConsulta)) {
        return
      }

      try {
        const result = await this.apiGet('funcionario/aso/dados-funcionario-consulta/' + idConsulta)
        const payload = this.responsePayload(result)

        if (payload && payload.existe) {
          this.dadosFuncionarioCerebro = {
            existe: true,
            idFuncionario: Number(payload.idFuncionario || 0),
            nomeMascarado: payload.nomeMascarado || '',
            cpfMascarado: payload.cpfMascarado || '',
            sexo: payload.sexo || '',
            data_nascimento: payload.data_nascimento || '',
            celular: payload.celular || '',
          }

          if (payload.sexo && !this.sexo) {
            this.sexo = payload.sexo
          }
          if (payload.data_nascimento && !this.dataNascimento) {
            this.dataNascimento = payload.data_nascimento
          }

          if (!this.cadastroExistente) {
            this.cadastroMaskedNome = payload.nomeMascarado || ''
            this.cadastroMaskedCpf = payload.cpfMascarado || ''
          }

          if (!this.telefone && payload.celular) {
            this.telefone = this.maskPhone(payload.celular)
          }
        }
      } catch (error) {
        // Falha silenciosa — campos ficam vazios para preenchimento manual
      }
    },
    onlyDigits(value) {
      return String(value || '').replace(/\D+/g, '')
    },
    maskCpf(value) {
      const digits = this.onlyDigits(value).slice(0, 11)
      const parts = [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9), digits.slice(9, 11)]
      return [parts[0], parts[1], parts[2]].filter(Boolean).join('.') + (parts[3] ? '-' + parts[3] : '')
    },
    maskPhone(value) {
      const digits = this.onlyDigits(value).slice(0, 11)
      if (digits.length <= 10) {
        return digits
          .replace(/(\d{2})(\d)/, '($1) $2')
          .replace(/(\d{4})(\d)/, '$1-$2')
      }

      return digits
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2')
    },
    setDocumentUploadState(side, loading, hasError) {
      if (side === 'frente') {
        this.uploadLoadingFrente = !!loading
        this.uploadErrorFrente = !!hasError
        return
      }

      this.uploadLoadingVerso = !!loading
      this.uploadErrorVerso = !!hasError
    },
    onDocumentSelected(payload) {
      if (!payload || !payload.file || !payload.side) {
        return
      }

      this.onSelectFile(payload.file, payload.side)
    },
    isSupportedImage(file) {
      if (!file || !file.type) {
        return false
      }

      return file.type === 'image/png' || file.type === 'image/jpeg'
    },
    isSupportedDocument(file) {
      if (!file || !file.type) {
        return false
      }

      return file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'application/pdf'
    },
    async fileToDataUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(String(reader.result || ''))
        reader.onerror = () => reject(new Error('Falha ao ler arquivo.'))
        reader.readAsDataURL(file)
      })
    },
    async onSelectFile(input, side) {
      var file = input && input.target && input.target.files && input.target.files[0]
        ? input.target.files[0]
        : input

      if (!file) {
        return
      }

      if (side === 'verso' && !this.frenteDocumento) {
        this.setStepMessage('Envie primeiro a frente do documento.', true)
        return
      }

      this.setDocumentUploadState(side, true, false)

      if (!this.isSupportedDocument(file)) {
        this.setStepMessage('Formato inválido. Envie imagem PNG, JPEG ou PDF.', true)
        this.setDocumentUploadState(side, false, true)
        return
      }

      try {
        var dataUrl = await this.fileToDataUrl(file)
        var isPdf = file.type === 'application/pdf'

        if (side === 'frente') {
          this.frenteDocumento = dataUrl
          this.frenteDocumentoName = file.name
          this.frenteIsPdf = isPdf

          if (isPdf) {
            this.versoDocumento = ''
            this.versoDocumentoName = ''
            this.uploadLoadingVerso = false
            this.uploadErrorVerso = false
          }

          this.setDocumentUploadState(side, false, false)
          return
        }

        this.versoDocumento = dataUrl
        this.versoDocumentoName = file.name
        this.setDocumentUploadState(side, false, false)
      } catch (error) {
        this.setStepMessage('Não foi possível ler o arquivo selecionado.', true)
        this.setDocumentUploadState(side, false, true)
      }
    },
    async onSelectFace(file) {
      if (!file) {
        return
      }

      this.setFaceUploadState(true, false)

      if (!this.isSupportedImage(file)) {
        this.setStepMessage('Formato invalido. Envie apenas imagem PNG ou JPEG.', true)
        this.setFaceUploadState(false, true)
        return
      }

      try {
        this.fotoRosto = await this.fileToDataUrl(file)
        this.fotoRostoName = file.name
        this.setFaceUploadState(false, false)
      } catch (error) {
        this.setStepMessage('Não foi possível carregar a foto do rosto.', true)
        this.setFaceUploadState(false, true)
      }
    },
    setFaceUploadState(loading, hasError) {
      this.uploadLoadingRosto = !!loading
      this.uploadErrorRosto = !!hasError
    },
    validatePasswordConfirmation() {
      if (!this.passwordConfirm) {
        return 'Confirme a senha.'
      }

      if (this.password !== this.passwordConfirm) {
        return 'As senhas não conferem.'
      }

      return ''
    },
    onPasswordConfirmBlur() {
      this.passwordConfirmTouched = true
      this.passwordConfirmError = this.validatePasswordConfirmation()
    },
    onPasswordConfirmInput() {
      if (!this.passwordConfirmTouched) {
        return
      }

      this.passwordConfirmError = this.validatePasswordConfirmation()
    },
    async validarCpf() {
      const idConsulta = Number(this.idConsulta)
      const usarDadosFuncionario = this.possuiDadosCerebro && !this.funcionarioCerebroEditavel

      this.setStepMessage('', false)

      if (!usarDadosFuncionario) {
        const cpf = this.onlyDigits(this.cpf)

        if (!this.nome || this.nome.trim().length < 3) {
          this.setStepMessage('Informe o nome completo.', true)
          return
        }

        if (cpf.length !== 11) {
          this.setStepMessage('Informe um CPF válido com 11 dígitos.', true)
          return
        }

        if (!this.sexo) {
          this.setStepMessage('Selecione o sexo.', true)
          return
        }

        if (!this.dataNascimento) {
          this.setStepMessage('Informe a data de nascimento.', true)
          return
        }
      }

      if (!idConsulta || Number.isNaN(idConsulta)) {
        this.setStepMessage('Consulta inválida.', true)
        return
      }

      this.busy = true

      try {
        var requestPayload = { idConsulta }

        if (usarDadosFuncionario) {
          requestPayload.usarDadosFuncionario = true
          requestPayload.idFuncionario = this.dadosFuncionarioCerebro.idFuncionario
        } else {
          var cpfDigits = this.onlyDigits(this.cpf)
          this.cpf = this.maskCpf(cpfDigits)
          requestPayload.cpf = cpfDigits
        }

        const result = await this.apiPost('funcionario/aso/validar-info', requestPayload)

        const payload = this.responsePayload(result)

        if (payload.valido) {
          this.currentStep = 3
          this.setStepMessage('Identidade validada. Continue com a assinatura.', false)
          this.goToBoardRoute()
          return
        }

        this.setStepMessage(payload.message || 'CPF não confere com a consulta informada.', true)
      } catch (error) {
        this.setStepMessage('Não foi possível validar o CPF agora. Tente novamente.', true)
      } finally {
        this.busy = false
      }
    },
    async confirmarCadastro() {
      const cpf = this.onlyDigits(this.cpf)
      const telefone = this.onlyDigits(this.telefone)
      const email = String(this.email || '').trim().toLowerCase()

      this.setStepMessage('', false)

      if (this.cadastroExistente) {
        if (!this.cadastroEditavel) {
          this.currentStep = 4
          this.setStepMessage('Dados mantidos com sucesso. Envie os documentos para avançar.', false)
          return
        }

        if (!this.nome || this.nome.trim().length < 3) {
          this.setStepMessage('Informe o nome completo.', true)
          return
        }

        if (telefone.length < 10) {
          this.setStepMessage('Informe um celular válido.', true)
          return
        }

        if (!email || email.indexOf('@') === -1) {
          this.setStepMessage('Informe um e-mail válido.', true)
          return
        }

        this.busy = true
        try {
          if (this.cadastroUsuarioId) {
            const updatePayload = await this.atualizarCadastroUsuarioTrabalhador()
            if (updatePayload && updatePayload.success === false) {
              this.setStepMessage(updatePayload.message || 'Não foi possível atualizar os dados.', true)
              return
            }
          } else {
            const updateResult = await this.apiPost('funcionario/aso/atualizar-cadastro-existente', {
              cpf,
              nome: this.nome.trim(),
              celular: telefone,
              email,
            })

            const updatePayload = this.responsePayload(updateResult)
            if (updatePayload && updatePayload.success === false) {
              this.setStepMessage(updatePayload.message || 'Não foi possível atualizar os dados.', true)
              return
            }
          }

          await this.carregarCadastroPorCpf(cpf)
          this.currentStep = 4
          this.setStepMessage('Dados atualizados com sucesso. Envie os documentos para avançar.', false)
        } catch (error) {
          this.setStepMessage('Não foi possível atualizar os dados. Tente novamente.', true)
        } finally {
          this.busy = false
        }

        return
      }

      if (!this.nome || this.nome.trim().length < 3) {
        this.setStepMessage('Informe o nome completo.', true)
        return
      }

      if (telefone.length < 10) {
        this.setStepMessage('Informe um celular válido.', true)
        return
      }

      if (!this.password || this.password.length < 4) {
        this.setStepMessage('Informe uma senha com ao menos 4 caracteres.', true)
        return
      }

      this.passwordConfirmTouched = true
      this.passwordConfirmError = this.validatePasswordConfirmation()
      if (this.passwordConfirmError) {
        this.setStepMessage(this.passwordConfirmError + ' Verifique e tente novamente.', true)
        return
      }

      if (!email || email.indexOf('@') === -1) {
        this.setStepMessage('O e-mail precisa ser validado no passo 1.', true)
        return
      }

      this.busy = true

      try {
        this.telefone = this.maskPhone(telefone)
        this.email = email

        const cadastroResult = await this.apiPost('funcionario/aso/criar-usuario', {
          email,
          password: this.password,
          cpf,
          nome: this.nome.trim(),
          telefone,
        })

        const cadastroPayload = this.responsePayload(cadastroResult)
        if (cadastroPayload && cadastroPayload.trabalhador_id) {
          this.trabalhadorId = Number(cadastroPayload.trabalhador_id)
        }

        await this.apiPost('funcionario/aso/validar-info-trabalhador', {
          cpf,
          nome: this.nome.trim(),
          celular: telefone,
        })

        this.currentStep = 4
        this.setStepMessage('Cadastro confirmado. Envie os documentos para avançar.', false)
      } catch (error) {
        this.setStepMessage('Não foi possível confirmar o cadastro. Revise os dados e tente novamente.', true)
      } finally {
        this.busy = false
      }
    },
    async carregarCadastroPorCpf(cpf) {
      const idResult = await this.apiGet('funcionario/aso/id-por-cpf/' + cpf)
      const idPayload = this.responsePayload(idResult)
      if (idPayload && idPayload.id) {
        this.trabalhadorId = Number(idPayload.id)
      }

      const cadastroResult = await this.apiGet('funcionario/aso/cadastro-por-cpf/' + cpf)
      const cadastroPayload = this.responsePayload(cadastroResult)
      this.hidratarCadastroExistente(cadastroPayload)
    },
    async carregarDadosMascaradosPorEmail(email) {
      const encoded = encodeURIComponent(String(email || '').trim().toLowerCase())
      const result = await this.apiGet('funcionario/aso/dados-mascarado-trabalhador/' + encoded)
      const payload = this.responsePayload(result)

      if (payload && payload.existe) {
        this.cadastroUsuarioId = Number(payload.id_usuario || 0)
        this.cadastroMaskedNome = payload.nomeMascarado || ''
        this.cadastroMaskedCpf = payload.cpfMascarado || ''
        this.cadastroMaskedTelefone = payload.celularMascarado || ''
        this.cadastroMaskedEmail = payload.emailMascarado || ''
        this.dataNascimento = payload.data_nascimento
          || (this.dadosFuncionarioCerebro && this.dadosFuncionarioCerebro.data_nascimento)
          || ''
        this.sexo = payload.sexo
          || (this.dadosFuncionarioCerebro && this.dadosFuncionarioCerebro.sexo)
          || ''
        if (payload.id_trabalhador) {
          this.trabalhadorId = Number(payload.id_trabalhador)
        }
      }
    },
    async atualizarCadastroUsuarioTrabalhador() {
      const payload = { id_usuario: this.cadastroUsuarioId }

      if (this.nome && this.nome.trim()) {
        payload.nome = this.nome.trim()
      }

      const cpfDigits = this.onlyDigits(this.cpf)
      if (cpfDigits && cpfDigits.length === 11) {
        payload.cpf = cpfDigits
      }

      if (this.sexo) {
        payload.sexo = this.sexo
      }

      if (this.dataNascimento) {
        payload.data_nascimento = this.dataNascimento
      }

      const email = String(this.email || '').trim().toLowerCase()
      if (email && email.indexOf('@') !== -1) {
        payload.email = email
      }

      const result = await this.apiPost('funcionario/aso/atualizar-cadastro-usuario-trabalhador', payload)
      return this.responsePayload(result)
    },
    hidratarCadastroExistente(payload) {
      this.cadastroExistente = !!(payload && payload.usuarioExiste)
      if (!this.cadastroEdicaoAtivada) {
        this.cadastroEditavel = false
      }

      if (!payload || !payload.existe) {
        this.cadastroMaskedNome = ''
        this.cadastroMaskedTelefone = ''
        this.cadastroMaskedEmail = ''
        return
      }

      this.cadastroMaskedNome = payload.nomeMascarado || ''
      this.cadastroMaskedTelefone = payload.celularMascarado || ''
      this.cadastroMaskedEmail = payload.emailMascarado || ''

      if (this.cadastroExistente) {
        if (!this.cadastroEdicaoAtivada) {
          this.nome = this.cadastroMaskedNome
          this.telefone = this.cadastroMaskedTelefone
          this.email = this.cadastroMaskedEmail
        }
        return
      }
    },
    onFuncionarioCerebroEditavelToggle() {
      if (!this.possuiDadosCerebro) {
        return
      }

      if (this.funcionarioCerebroEditavel) {
        this.funcionarioCerebroEdicaoAtivada = true
        this.nome = ''
        this.cpf = ''
        this.sexo = ''
        this.dataNascimento = ''
      } else {
        this.cadastroMaskedNome = this.dadosFuncionarioCerebro.nomeMascarado || ''
        this.cadastroMaskedCpf = this.dadosFuncionarioCerebro.cpfMascarado || ''
        this.sexo = this.dadosFuncionarioCerebro.sexo || ''
        this.dataNascimento = this.dadosFuncionarioCerebro.data_nascimento || ''
      }

      this.setStepMessage('', false)
    },
    onCadastroEditavelToggle() {
      if (!this.cadastroExistente) {
        return
      }

      if (this.cadastroEditavel) {
        this.cadastroEdicaoAtivada = true
      }

      this.setStepMessage('', false)
    },
    async confirmarDadosExistente() {
      this.setStepMessage('', false)

      if (this.cadastroEditavel) {
        this.busy = true
        try {
          if (this.cadastroUsuarioId) {
            const result = await this.atualizarCadastroUsuarioTrabalhador()
            if (result && result.success === false) {
              this.setStepMessage(result.message || 'Não foi possível atualizar os dados.', true)
              return
            }
          }
        } catch (error) {
          this.setStepMessage('Não foi possível atualizar os dados.', true)
          return
        } finally {
          this.busy = false
        }
      }

      if (this.cadastroExistente) {
        if (this.possuiAssinaturaAnterior) {
          this.currentStep = 7
          this.persistWizardState()
          this.goToBoardRoute()
          this.salvarAssinatura()
          return
        }

        this.currentStep = 5
        this.persistWizardState()
        this.setStepMessage('Dados confirmados. Continue com o upload dos documentos.', false)
        this.goToBoardRoute()
        return
      }

      this.currentStep = 5
      this.persistWizardState()
      this.setStepMessage('Dados confirmados. Continue com o upload dos documentos.', false)
      this.goToBoardRoute()
    },
    async enviarTokenEmail() {
      const email = String(this.email || '').trim().toLowerCase()
      if (!email || email.indexOf('@') === -1) {
        this.setStepMessage('Informe um e-mail válido.', true)
        return
      }

      this.busy = true
      try {
        const checkResult = await this.apiGet('funcionario/aso/verificar-email/' + encodeURIComponent(email))
        const checkPayload = this.responsePayload(checkResult)

        if (checkPayload && checkPayload.emailEncontrado === false) {
          this.setStepMessage(checkPayload.message || 'Esse e-mail não pode ser utilizado.', true)
          return
        }

        if (checkPayload && checkPayload.emailCadastrado) {
          this.cadastroExistente = true
          this.possuiAssinaturaAnterior = !!checkPayload.possuiAssinaturaAnterior
          await this.carregarDadosMascaradosPorEmail(email)
          this.currentStep = 2
          this.setStepMessage('E-mail já cadastrado. Confira seus dados.', false)
          this.goToValidationRoute('identidade')
          return
        }

        this.busy = false
        const sent = await this.enviarToken('email')
        if (sent) {
          this.goToEmailTokenForm()
        }
      } catch (error) {
        this.setStepMessage('Não foi possível verificar o e-mail.', true)
      } finally {
        this.busy = false
      }
    },
    async reenviarTokenEmail() {
      if (!this.tokenExpired) {
        return
      }

      await this.enviarToken('email')
      this.emailTokenValues = ['', '', '', '']
      this.$nextTick(() => this.focusTokenDigit(0, 'email'))
    },
    async enviarTokenTelefone() {
      const sent = await this.enviarToken('sms')
      if (sent) {
        this.goToPhoneTokenForm()
      }
    },
    async reenviarTokenTelefone() {
      if (!this.tokenExpired) {
        return
      }

      await this.enviarToken('sms')
      this.phoneTokenValues = ['', '', '', '']
      this.$nextTick(() => this.focusTokenDigit(0, 'phone'))
    },
    async enviarToken(channel) {
      const email = String(this.email || '').trim().toLowerCase()
      const telefone = this.onlyDigits(this.telefone)

      this.setStepMessage('', false)

      if (channel === 'email') {
        if (!email || email.indexOf('@') === -1) {
          this.setStepMessage('Informe um e-mail válido para receber o token.', true)
          return false
        }
      } else if (telefone.length < 10) {
        this.setStepMessage('Informe um celular válido para receber o token.', true)
        return false
      }

      this.busy = true

      try {
        if (channel === 'email') {
          const emailCheckResult = await this.apiGet('funcionario/aso/verificar-email/' + encodeURIComponent(email))
          const emailCheckPayload = this.responsePayload(emailCheckResult)
          if (emailCheckPayload && emailCheckPayload.emailEncontrado === false) {
            this.setStepMessage(emailCheckPayload.message || 'Esse e-mail não pode ser utilizado.', true)
            return false
          }
        }

        if (channel === 'email') {
          const emailResult = await this.apiPost('funcionario/aso/disparar-email', { email })
          this.tokenChannel = 'email'
          this.setTokenExpiry()
          this.setStepMessage(this.responseMessage(emailResult, 'Token enviado por e-mail.'), false)
          return true
        }

        const smsResult = await this.apiPost('funcionario/aso/disparar-sms', { telefoneInput: telefone })
        this.tokenChannel = 'sms'
        this.setTokenExpiry()
        this.setStepMessage(this.responseMessage(smsResult, 'Token enviado por SMS.'), false)
        return true
      } catch (error) {
        this.setStepMessage('Não foi possível disparar o token agora.', true)
        return false
      } finally {
        this.busy = false
      }
    },
    async validarToken() {
      const token = this.onlyDigits(this.emailTokenValues.join(''))
      const telefone = this.onlyDigits(this.telefone)
      const email = String(this.email || '').trim().toLowerCase()

      this.setStepMessage('', false)

      if (token.length !== 4) {
        this.setStepMessage('Informe os 4 dígitos do token recebido.', true)
        return
      }

      if (this.tokenExpiresAt && this.tokenExpired) {
        this.setStepMessage('Token expirado. Solicite um novo token.', true)
        return
      }

      this.busy = true

      try {
        const result = await this.apiPost('funcionario/aso/validar-token', {
          token,
          email,
          telefoneInput: telefone,
        })

        const payload = this.responsePayload(result)
        if (payload && payload.valido) {
          this.currentStep = 2
          this.emailValidationView = 'email'
          this.emailTokenValues = ['', '', '', '']
          this.tokenExpiresAt = 0
          this.stopTokenTimer()
          this.setStepMessage('E-mail validado com sucesso. Agora confirme sua identidade.', false)
          this.goToBoardRoute()
          return
        }

        this.setStepMessage(payload.message || 'Token inválido ou expirado.', true)
      } catch (error) {
        this.setStepMessage('Não foi possível validar o token.', true)
      } finally {
        this.busy = false
      }
    },
    async validarTokenTelefone() {
      const token = this.onlyDigits(this.phoneTokenValues.join(''))
      const telefone = this.onlyDigits(this.telefone)
      const email = String(this.email || '').trim().toLowerCase()

      this.setStepMessage('', false)

      if (token.length !== 4) {
        this.setStepMessage('Informe os 4 dígitos do token recebido.', true)
        return
      }

      if (this.tokenExpiresAt && this.tokenExpired) {
        this.setStepMessage('Token expirado. Solicite um novo token.', true)
        return
      }

      this.busy = true

      try {
        const result = await this.apiPost('funcionario/aso/validar-token', {
          token,
          email,
          telefoneInput: telefone,
        })

        const payload = this.responsePayload(result)
        if (payload && payload.valido) {
          this.currentStep = 4
          this.phoneValidationView = 'phone'
          this.phoneTokenValues = ['', '', '', '']
          this.tokenExpiresAt = 0
          this.stopTokenTimer()
          this.setStepMessage('Telefone validado com sucesso. Agora crie sua senha.', false)
          this.goToBoardRoute()
          return
        }

        this.setStepMessage(payload.message || 'Token inválido ou expirado.', true)
      } catch (error) {
        this.setStepMessage('Não foi possível validar o token de telefone.', true)
      } finally {
        this.busy = false
      }
    },
    validarSenha() {
      this.passwordConfirmTouched = true
      this.passwordConfirmError = this.validatePasswordConfirmation()

      const hasUpper = /[A-Z]/.test(this.password)
      const hasLower = /[a-z]/.test(this.password)
      const hasNumber = /\d/.test(this.password)
      const hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.password)
      const strongEnough = this.password && this.password.length >= 8 && hasUpper && hasLower && hasNumber && hasSpecial

      if (!strongEnough) {
        this.setStepMessage('A senha é muito fraca. Use 8+ caracteres com maiúscula, minúscula, número e símbolo.', true)
        return
      }

      if (this.passwordConfirmError) {
        this.setStepMessage(this.passwordConfirmError + ' Verifique e tente novamente.', true)
        return
      }

      this.registrarNovoCadastro()
    },
    async registrarNovoCadastro() {
      const cpf = this.onlyDigits(this.cpf)
      const telefone = this.onlyDigits(this.telefone)
      const email = String(this.email || '').trim().toLowerCase()
      const usarDadosFuncionario = this.possuiDadosCerebro && !this.funcionarioCerebroEditavel

      this.setStepMessage('', false)

      if (!email || email.indexOf('@') === -1) {
        this.setStepMessage('O e-mail precisa ser validado no passo 1.', true)
        return
      }

      this.busy = true

      try {
        var criarUsuarioPayload = {
          email,
          password: this.password,
          telefone,
        }

        if (usarDadosFuncionario) {
          criarUsuarioPayload.usarDadosFuncionario = true
          criarUsuarioPayload.idFuncionario = this.dadosFuncionarioCerebro.idFuncionario
        } else {
          criarUsuarioPayload.cpf = cpf
          criarUsuarioPayload.nome = this.nome.trim()
          criarUsuarioPayload.sexo = this.sexo
          criarUsuarioPayload.data_nascimento = this.dataNascimento
        }

        const cadastroResult = await this.apiPost('funcionario/aso/criar-usuario', criarUsuarioPayload)

        const cadastroPayload = this.responsePayload(cadastroResult)
        if (cadastroPayload && cadastroPayload.trabalhador_id) {
          this.trabalhadorId = Number(cadastroPayload.trabalhador_id)
        }

        if (!usarDadosFuncionario) {
          await this.apiPost('funcionario/aso/validar-info-trabalhador', {
            cpf,
            nome: this.nome.trim(),
            celular: telefone,
          })
        }

        this.currentStep = 5
        this.setStepMessage('Cadastro confirmado. Continue com o upload dos documentos.', false)
        this.goToBoardRoute()
      } catch (error) {
        this.setStepMessage('Não foi possível confirmar o cadastro. Tente novamente.', true)
      } finally {
        this.busy = false
      }
    },
    async salvarDocumentos() {
      const email = String(this.email || '').trim().toLowerCase()

      this.setStepMessage('', false)

      if (!this.frenteDocumento || (!this.frenteIsPdf && !this.versoDocumento)) {
        this.setStepMessage(this.frenteIsPdf ? 'Selecione o documento PDF.' : 'Selecione frente e verso do documento.', true)
        return
      }

      this.busy = true

      try {
        var payload = {
          email: email,
          idConsulta: Number(this.idConsulta),
          frenteDocumento: this.frenteDocumento,
        }

        if (!this.frenteIsPdf) {
          payload.versoDocumento = this.versoDocumento
        }

        var result = await this.apiPost('funcionario/aso/salvar-documentos', payload)

        const status = this.responseStatus(result)
        const payload = this.responsePayload(result)

        if (status && status !== 200) {
          this.uploadErrorFrente = true
          this.uploadErrorVerso = true
          this.logRequestError('salvarDocumentos:status', { status, payload, result })
          this.setStepMessage(SUPPORT_ERROR_MESSAGE, true)
          return
        }

        if (payload && payload.success === false) {
          this.uploadErrorFrente = true
          this.uploadErrorVerso = true
          this.logRequestError('salvarDocumentos:payload', { payload, result })
          this.setStepMessage(SUPPORT_ERROR_MESSAGE, true)
          return
        }

        this.uploadErrorFrente = false
        this.uploadErrorVerso = false

        this.currentStep = 6
        this.setStepMessage(this.responseMessage(result, 'Documentos enviados com sucesso.'), false)
      } catch (error) {
        this.uploadErrorFrente = true
        this.uploadErrorVerso = true
        this.logRequestError('salvarDocumentos:exception', error)
        this.setStepMessage(SUPPORT_ERROR_MESSAGE, true)
      } finally {
        this.busy = false
      }
    },
    async salvarAssinatura() {
      const idConsulta = Number(this.idConsulta)
      const cpf = this.onlyDigits(this.cpf)

      this.setStepMessage('', false)

      if (!this.fotoRosto && !(this.cadastroExistente && this.possuiAssinaturaAnterior)) {
        this.setStepMessage('Selecione uma foto do rosto para finalizar.', true)
        return
      }

      this.busy = true

      try {
        let trabalhadorId = Number(this.trabalhadorId || 0)
        if (!trabalhadorId && cpf) {
          const idResult = await this.apiGet('funcionario/aso/id-por-cpf/' + cpf)
          const idPayload = this.responsePayload(idResult)
          trabalhadorId = idPayload && idPayload.id ? Number(idPayload.id) : 0
        }

        var usarDadosFuncionario = this.possuiDadosCerebro && !this.funcionarioCerebroEditavel

        const payload = {
          idConsulta,
          fotoRosto: this.fotoRosto,
          celular: this.onlyDigits(this.telefone),
          email: (this.email || '').trim().toLowerCase(),
          password: this.password || '',
        }

        if (usarDadosFuncionario) {
          payload.usarDadosFuncionario = true
          payload.idFuncionario = this.dadosFuncionarioCerebro.idFuncionario
        } else {
          payload.nome = (this.nome || '').trim()
          payload.sexo = this.sexo || ''
          payload.data_nascimento = this.dataNascimento || ''
          payload.cpf = cpf
        }

        if (trabalhadorId) {
          payload.id = trabalhadorId
        }

        const result = await this.apiPost('funcionario/aso/salvar-assinatura', payload)
        const responsePayload = this.responsePayload(result)
        if (responsePayload && responsePayload.success === false) {
          this.setStepMessage(responsePayload.message || 'Não foi possível concluir a assinatura.', true)
          return
        }

        this.justSigned = true
        this.wizardComplete = true
        this.setStepMessage(this.responseMessage(result, 'Documento assinado com sucesso.'), false)
        this.clearWizardState()
        await this.loadAssinaturaStatus()
      } catch (error) {
        this.setStepMessage('Erro ao concluir assinatura. Tente novamente.', true)
      } finally {
        this.busy = false
      }
    },
  },
  watch: {
    '$route.params.step'() {
      this.syncStepFromRoute()
    },
    cpf(value) {
      this.cpf = this.maskCpf(value)
    },
    telefone(value) {
      if (this.cadastroExistente && !this.cadastroEditavel) {
        return
      }

      this.telefone = this.maskPhone(value)
    },
    currentStep() {
      this.persistWizardState()
    },
    nome() {
      this.persistWizardState()
    },
    email() {
      this.persistWizardState()
    },
    tokenChannel() {
      this.persistWizardState()
    },
    tokenExpiresAt() {
      this.persistWizardState()
      this.ensureTokenTimer()
    },
    trabalhadorId() {
      this.persistWizardState()
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/apps/funcionario/aso/assinar/wizard.mixin.js